module.exports = __webpack_public_path__ + "img/pic_3.0865352b.jpg";